import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "16",
  "aria-hidden": "true",
  viewBox: "0 0 18 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.894 0a2.5 2.5 0 0 1 1.79.754l1.508 1.532h5.558C16.991 2.286 18 3.31 18 4.57v2.79l-1.688-.309v-2.48A.57.57 0 0 0 15.75 4h-5.674c-.373 0-.731-.15-.995-.418L7.49 1.964a.84.84 0 0 0-.597-.25H2.25a.57.57 0 0 0-.563.572v11.428a.57.57 0 0 0 .563.572l5.192-.001L7.13 16l2.352.002a.66.66 0 0 1-.358-.13.7.7 0 0 1-.269-.672l.513-3.13-2.171-2.214a.7.7 0 0 1-.165-.703.67.67 0 0 1 .536-.466l2.991-.455L11.9 5.39a.67.67 0 0 1 .6-.387c.256 0 .489.15.6.387l1.339 2.842 2.993.455c.25.039.457.22.536.466a.7.7 0 0 1-.165.703l-2.17 2.215.514 3.13a.7.7 0 0 1-.269.672.65.65 0 0 1-.352.129l.251-.002h-.026l-.24.003h-.053l-5.915-.001h-.047L2.25 16C1.009 16 0 14.975 0 13.714V2.286C0 1.025 1.009 0 2.25 0zm8.28 15.922L12.5 14.451l-2.673 1.471a.7.7 0 0 1-.275.08h5.892a.7.7 0 0 1-.272-.08Z" }, null, -1)
  ])))
}
export default { render: render }